import React from "react";
import * as util from "../../../other/util.js";
import FleetTaskFactory from "./fleet-task-factory.js";

export class FleetTaskCreateButton extends React.Component {
    constructor(props) {
        super(props);
        this.state = { showTaskChooser: false };
    }

    render() {
        let button_html = (
            <div className="action-button"
                onClick={() => this.setState({ showTaskChooser: !this.state.showTaskChooser })}>Add Assignment
            </div>);

        if (!this.state.showTaskChooser) {
            return button_html;
        }

        let colo_task;
        if (this._hasColoShip()) {
            colo_task = (<div className="link-button" onClick={() => this._handleClick("COLONIZE")}>Colonize</div>)
        }

        return (
            <div className="modal-host">
                {button_html}
                <div className="modal">
                    <div className="link-button" onClick={() => this._handleClick("MOVE")}>Move</div>
                    <br />
                    {colo_task}
                    <div className="link-button" onClick={() => this._handleClick("STATION")}>Station</div>
                    <br />
                    <div className="link-button" onClick={() => this._handleClick("RAID")}>Raid</div>
                    <br />
                    <div className="link-button" onClick={() => this._handleClick("REPAIR")}>Repair</div>
                    <br />
                    <div className="link-button" onClick={() => this._handleClick("MISSION")}>Mission</div>
                </div>
            </div>
        );
    }

    _hasColoShip() {
        const ships = this.props.fleet.ships;
        for (let idx = 0; idx < ships.length; idx++) {
            if (ships[idx].design.config.colo > 0) {
                return true;
            }
        }
        return false;
    }

    _handleClick(task_type) {
        this.setState({ showTaskChooser: false });
        this.props.onCreateTask(FleetTaskFactory.createTask(task_type, true));
    }
}